// hooks/useToast.js
import { useState, useCallback } from "react";

export const useToast = () => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("info");
  const [canClose, setCanClose] = useState(false);
  const [autoHide, setAutoHide] = useState(false);
  const [autoHideDuration, setAutoHideDuration] = useState(null);

  const setOptions = useCallback((options) => {
    setCanClose(options?.canClose ?? true);
    setAutoHide(options?.autoHide ?? true);
    setAutoHideDuration(options?.autoHideDuration || 6000);
  }, []);

  const showToast = useCallback((newMessage, newSeverity = "info", options) => {
    setMessage(newMessage);
    setSeverity(newSeverity);
    setOpen(true);
    setOptions(options);
  }, []);

  const showLoading = useCallback((loadingMessage = "Loading...", options) => {
    setMessage(loadingMessage);
    setSeverity("loading");
    setOpen(true);
    setOptions(options);
  }, []);

  const hideToast = useCallback((event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  }, []);

  return {
    open,
    message,
    severity,
    canClose,
    autoHide,
    autoHideDuration,
    showToast,
    showLoading,
    hideToast,
  };
};
